// eslint-disable-next-line max-classes-per-file
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  HostBinding,
  Directive,
} from '@angular/core';
import { Token } from '@cigna/resource-content/contracts';
import { Renderer } from './renderer.interface';

@Directive()
export abstract class FormattingRendererDirective implements Renderer {
  @Input() token: Token;

  @HostBinding('attr.class') get class() {
    return this.token[2];
  }
}

@Component({
  selector: 'p',
  template:
    // eslint-disable-next-line sonarjs/no-duplicate-string
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParagraphRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'b',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoldRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'strong',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrongRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'br',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreakRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'i',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItalicRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'em',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'sup',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'sub',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubRendererComponent extends FormattingRendererDirective {}

@Component({
  selector: 'span',
  template:
    '<ng-template [cignaContentRenderer]="token[1]" let-text>{{ text }}</ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpanRendererComponent extends FormattingRendererDirective {}
